import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { EventTypesView } from '../../../../modules/bookings/event-types-view'
import '../../../../modules/bookings/register-panels'

const searchSchema = z.object({
  q: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
  owner: z.enum(['mine', 'all']).optional(),
  panel: z.string().optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
})

export const Route = createFileRoute('/_authed/bookings/event-types/')({
  validateSearch: searchSchema,
  component: EventTypesRoute,
})

function EventTypesRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <EventTypesView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => {
            const next: Record<string, unknown> = { ...prev, ...patch }
            for (const [key, value] of Object.entries(next)) {
              if (value == null || value === '') delete next[key]
            }
            return next
          }) as never,
          replace: true,
        })
      }
    />
  )
}
